export default defineNuxtRouteMiddleware(() => {})
